import axios from "axios";
const BASE_URL = process.env.REACT_APP_API_URL;

export const getPointsStatistics = async () => {
  try {
    const token = localStorage.getItem("access_token");

    const response = await axios.get(
      `${BASE_URL}referrals/points/statistics`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: token ? `Bearer ${token}` : "",
        },
      }
    );

    return response.data;
  } catch (error) {
    // Centralized error handling
    if (error.response) {
      throw error.response.data;
    }
    throw error;
  }
};

export const applyReferralCode = async (referralCode) => {
  try {
    const token = localStorage.getItem("access_token");

    const response = await axios.post(
      `${BASE_URL}referrals/apply`,
      { referral_code: referralCode },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: token ? `Bearer ${token}` : "",
        },
      }
    );

    return response.data;
  } catch (error) {
    if (error.response) {
      throw error.response.data;
    }
    throw error;
  }
};

export const getReferredUsers = async () => {
  try {
    const token = localStorage.getItem("access_token");

    const response = await axios.get(
      `${BASE_URL}referrals/referred-users`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: token ? `Bearer ${token}` : "",
        },
      }
    );

    return response.data;
  } catch (error) {
    // Centralized error handling
    if (error.response) {
      throw error.response.data;
    }
    throw error;
  }
};

export const regenerateReferralCode = async () => {
  try {
    const token = localStorage.getItem("access_token");

    const response = await axios.post(
      `${BASE_URL}referrals/regenerate-code`,
      {},
      {
        headers: {
          "Content-Type": "application/json",
          "accept": "application/json",
          Authorization: token ? `Bearer ${token}` : "",
        },
      }
    );

    return response.data;
  } catch (error) {
    if (error.response) {
      throw error.response.data;
    }
    throw error;
  }
};




